import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { BMSCommonStepperHorizontalComponent } from './horizontal-stepper/bms-common-stepper-horizontal.component';
import { BMSCommonStepperVerticalComponent } from './vertical-stepper/bms-common-stepper-vertical.component';

export interface IBMSCommonStepperData {
  stepper: string;
  completed: boolean;
  tooltip?: string;
}

@Component({
  selector: 'bms-common-stepper',
  templateUrl: './bms-common-stepper.component.html',
  styleUrls: ['./bms-common-stepper.component.scss'],
})
export class BMSCommonStepperComponent {
  @ViewChild(BMSCommonStepperHorizontalComponent)
  stepperComp1: BMSCommonStepperHorizontalComponent;
  @ViewChild(BMSCommonStepperVerticalComponent)
  stepperComp2: BMSCommonStepperVerticalComponent;

  windowWidth = window;
  @Output() onStepperChange: EventEmitter<StepperSelectionEvent> =
    new EventEmitter();
  @Input() stepperData: IBMSCommonStepperData[] = [];

  onStepChange(e: StepperSelectionEvent) {
    this.onStepperChange.emit(e);
  }

  onClickBack() {
    this.stepperComp2?.goToPreviousStep();
    this.stepperComp1?.goToPreviousStep();
  }

  onClickNext() {
    this.stepperComp2?.goToNextStep();
    this.stepperComp1?.goToNextStep();
  }
}
